/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Priorityforcing1Inputs */



/**
* | output |
* | --- |
* | "Forced priority" |
*
* @param {Br_History_Key_Priorityforcing1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_priorityforcing1 = /** @type {((inputs?: Br_History_Key_Priorityforcing1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Priorityforcing1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Forced priority")
	return /** @type {LocalizedString} */ ("Priorité forcée")
});
export { br_history_key_priorityforcing1 as "br_history_key_priorityForcing" }